module.exports = __webpack_public_path__ + "static/media/uni-bg2.a966dfaf.png";